<div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_日期" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"></host-range-picker>
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_设置" | translate }}
      <!-- Settings -->
    </div>

    <div class="v4-filter-style mb-[20px]">
      <nz-select
        [nzOptions]="filterOpts"
        [nzDropdownMatchSelectWidth]="false"
        [(ngModel)]="filterMode"
        (ngModelChange)="onFilterModeChange($event)"></nz-select>
    </div>

    @if (filterMode === "mixed") {
      @for (house of listOfHouse; track $index) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label">
            <div class="flex flex-row items-center cursor-pointer" (click)="house.unfold = !house.unfold">
              <img
                [src]="(house.thirdparty_type | thirdparty)?.icon_color"
                alt=""
                class="w-[18px] h-[18px] rounded-full" />
              <span
                class="ml-1 mr-[2px] max-w-[300px] overflow-hidden whitespace-nowrap text-[#000000d9] text-ellipsis"
                [ngClass]="{
                  '!text-[#48CA93]': house.unique_key === entity?.c_id
                }">
                {{ house.thirdparty_house_title }}
              </span>
              <img
                class="w-[10px] h-[10px]"
                [class.rotate-180]="house.unfold"
                src="/assets/v4/icon-arrow-down.svg"
                alt="" />
            </div>
          </div>
        </div>
        <div class="pl-3" *ngIf="house.unfold">
          <widget-rules-settings-form
            [house]="house"
            [dateRange]="dateRange"
            (onSave)="onFormSaved($event)"></widget-rules-settings-form>
        </div>
      }
    } @else {
      @if (filterMode !== "rule_id") {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label flex-1">
            {{ "batch_modify_restrictions_html_restriction_quick_edit" | translate }}
          </div>

          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row justify-end">
              @switch (filterMode) {
                @case ("min_advance_reservation") {
                  <div class="flex flex-row">
                    <input
                      type="number"
                      nz-input
                      nzSize="large"
                      [placeholder]="'operate_sidebar-rules_settings_html_days' | translate"
                      class="w-[80px]"
                      [(ngModel)]="quickEditDaysValue"
                      (ngModelChange)="onQuickEdit('select')" />

                    <div class="w-[80px] ml-2">
                      <host-select
                        size="large"
                        [placeholder]="'operate_sidebar-rules_settings_html_hours' | translate"
                        [defaultValue]="null"
                        [listOfOption]="optionsOfMARHours"
                        [(ngModel)]="quickEditHoursValue"
                        (ngModelChange)="onQuickEdit('select')"></host-select>
                    </div>
                  </div>
                }

                @case ("max_advance_reservation") {
                  <div class="flex flex-row">
                    <input
                      type="number"
                      nz-input
                      nzSize="large"
                      [placeholder]="'operate_sidebar-rules_settings_html_days' | translate"
                      class="w-[80px]"
                      [(ngModel)]="quickEditDaysValue"
                      (ngModelChange)="onQuickEdit('select')" />
                  </div>
                }

                @case ("closed_on_arrival") {
                  <label nz-checkbox [(ngModel)]="quickEditValue" (ngModelChange)="onQuickEdit('checkbox')">
                    <!-- Enabled -->
                    {{ "property-property_detail-booking_setting_html_启用" | translate }}
                  </label>
                }

                @case ("closed_on_departure") {
                  <label nz-checkbox [(ngModel)]="quickEditValue" (ngModelChange)="onQuickEdit('checkbox')">
                    <!-- Enabled -->
                    {{ "property-property_detail-booking_setting_html_启用" | translate }}
                  </label>
                }

                @default {
                  <input
                    class="w-[80px]"
                    type="number"
                    nz-input
                    nzSize="large"
                    [(ngModel)]="quickEditValue"
                    (ngModelChange)="onQuickEdit('input')" />
                }
              }
            </div>
          </div>
        </div>
      }

      @for (house of listOfHouse; track $index) {
        <widget-rules-settings-form
          #rulesSettingsForm
          [mode]="filterMode"
          [activated]="house.unique_key === entity?.c_id"
          [house]="house"
          [dateRange]="dateRange"
          (onSave)="loading = $event"></widget-rules-settings-form>
      }
    }
  </div>

  <!-- <div class="v4-layout-form">
    <div>
      <a href="javascript:void(0)" (click)="onDisplayListingPr()">
        {{ "operate-sidebar_price_rules_html_listing_pr" | translate }}
      </a>
    </div>
    <div class="mt-[16px]">
      <a routerLink="/app/settings/custom-options" [queryParams]="{ anchor: 'cpr' }">
        {{ "operate-sidebar_price_rules_html_global_pr" | translate }}
      </a>
    </div>
  </div> -->

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" [nzLoading]="loading" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>

<ng-template #formStyleByRule>
  <div class="v4-layout-field">
    <div class="v4-layout-field-label w-[200px]">Quick edit</div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input type="text" nz-input />
      </div>
    </div>
  </div>

  <div class="v4-layout-field">
    <div class="v4-layout-field-label w-[200px]">
      <div class="flex flex-row items-center cursor-pointer">
        <img [src]="'/assets/status/placeholder.png'" alt="" class="w-[18px] h-[18px] rounded-full" />
        <span
          class="ml-1 mr-[2px] max-w-[300px] overflow-hidden whitespace-nowrap text-ellipsis"
          [ngClass]="{
            'text-[#48CA93]': true
          }">
          123455
        </span>
      </div>
    </div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <input type="text" nz-input />
      </div>
    </div>
  </div>
</ng-template>

<!-- <ng-template #subFields let-platform>
  <ng-container [ngSwitch]="platform">
    <div *ngSwitchCase="Platform.BOOKING">
      <widget-rules-settings-form></widget-rules-settings-form>
    </div>
  </ng-container>
</ng-template> -->
